module.exports = __webpack_public_path__ + "static/media/r6.de0dd9a1.png";